import { MouseEvent, useCallback, useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";

import { QUERIES } from "../../../../utils/constants";

export const useWorkItemNavigation = (selection: string | undefined) => {
  const isStacked = useMediaQuery(QUERIES.tabletLargeAndDown);
  const detailRef = useRef<HTMLElement>(null);
  const listRef = useRef<HTMLUListElement>(null);
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  const detailHadFocus = useRef(false);

  const focusDetail = useCallback(() => {
    const detail = detailRef.current;
    detail?.focus({ preventScroll: true });
    if (isStacked) {
      detail?.scrollIntoView({ block: "start", behavior: "instant" });
    }
  }, [isStacked]);

  // A decision or Next item replaces the focused button, which would otherwise drop focus to the page.
  useEffect(() => {
    if (detailHadFocus.current && document.activeElement === document.body) {
      focusDetail();
    }
  }, [selection, focusDetail]);

  const openDetail = (event: MouseEvent<HTMLButtonElement>) => {
    triggerRef.current = event.currentTarget;
    if (isStacked) {
      requestAnimationFrame(focusDetail);
    }
  };

  const backToList = () => {
    detailHadFocus.current = false;
    const target = triggerRef.current?.isConnected
      ? triggerRef.current
      : listRef.current?.querySelector("button");
    target?.focus({ preventScroll: true });
    target?.scrollIntoView({ block: "center", behavior: "instant" });
  };

  const handleDetailFocus = () => {
    detailHadFocus.current = true;
  };

  return {
    isStacked,
    detailRef,
    listRef,
    openDetail,
    backToList,
    handleDetailFocus,
  };
};
